import api from '../../api';

export const fetchGeneralSearch = (search) => api.get(`/lms/general_search?value=${search}`);